// Image data types based on backend response format

export interface ImageData {
    imageId: string;
    description: string;
    style: string;
    tags: string[];
    rating: number | null;
    imageCount: number;
    fileNames: string[];
    // Search scores
    score?: number;
    rerankerScore?: number;
}

// For API responses that might include additional metadata
export interface ImageListResponse {
    images: ImageData[];
    total: number;
    totalCount?: number;
    page: number;
    pageSize: number;
}

// For image filtering and search
export interface ImageFilters {
    imageId?: string;
    style?: string;
    tags?: string[];
    description?: string;
    hasRating?: boolean;
    minRating?: number;
    maxRating?: number;
    keyword?: string; // 新增关键词搜索字段
}

// For backend API query - matching QueryImageDto
export interface QueryImageDto {
    query: string; // 关键词搜索
    style: string; // 图片样式，空字符串表示 "All Styles"
    pageIndex: number; // 页码索引（从1开始）
    pageSize: number; // 每页大小
}

// For upload dialog form data
export interface UploadImageFormData {
    imageId: string;
    description: string;
    style: string;
    tags: string;
    rating: number | null;
    files: File[];
}

// For image update
export interface UpdateImageRequest {
    imageId: string;
    description: string;
    style: string;
    tags: string[];
    rating?: number | null;
    files: File[];
}

// Style options for dropdown
export interface StyleOption {
    key: string;
    text: string;
}

// Common image styles - can be expanded based on backend support
export const DEFAULT_STYLE_OPTIONS: StyleOption[] = [
    { key: "", text: "All Styles" },
    { key: "Architectural", text: "Architectural" },
    { key: "Minimalist", text: "Minimalist" },
    { key: "Universe", text: "Universe" },
    { key: "Gradient", text: "Gradient" },
    { key: "TechGradient", text: "Tech Gradient" },
    { key: "Texture", text: "Texture" },
    { key: "TechTexture", text: "Tech Texture" },
    { key: "Abstract", text: "Abstract" },
    { key: "TechAbstract", text: "Tech Abstract" },

];

// For image URL response
export interface ImageUrlResponse {
    urls: string[];
}

// For image detail dialog data
export interface ImageDetailData {
    imageId: string;
    description: string;
    style: string;
    tags: string[];
    rating: number | null;
    imageCount: number;
    urls: string[];
    fileNames: string[];
}
